'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');
const reactAriaComponents = require('react-aria-components');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const ModalDialogTrigger = ({ children }) => {
  return React__default.default.createElement(reactAriaComponents.DialogTrigger, null, children);
};

exports.ModalDialogTrigger = ModalDialogTrigger;
//# sourceMappingURL=Trigger.cjs.js.map
